var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var S3CsvImportConfig_1;
/* eslint-disable import/no-duplicates */
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './dataPreprocessConfig';
import { FlatFileImportConfig } from './flatFileImportConfig';
import { ImportConfigType } from './importConfig';
import { ImportOperation } from '../importTask';
import { s3CsvImportConfigSchemaValidation } from '../../validations.generated';
export const s3CsvImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:S3CsvImportConfig',
    type: 'object',
    properties: {
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quoteChar: { type: 'string', enum: ['"', "'"] },
        hasHeader: { type: 'boolean' },
        doDiscovery: { type: 'boolean' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    required: ['hasHeader']
};
let S3CsvImportConfig = S3CsvImportConfig_1 = class S3CsvImportConfig extends FlatFileImportConfig {
    constructor(s3File, delimiter, quoteChar, hasHeader, doDiscovery, dataPreprocessConfig, columnsToUpdate, dataCategory) {
        super(ImportConfigType.S3Csv, s3File, columnsToUpdate, dataCategory);
        this.delimiter = delimiter;
        this.quoteChar = quoteChar;
        this.hasHeader = hasHeader;
        if (doDiscovery !== undefined)
            this.doDiscovery = doDiscovery;
        if (dataPreprocessConfig !== undefined)
            this.dataPreprocessConfig = dataPreprocessConfig;
        JSON.validate(this, S3CsvImportConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite]; // ICM somehow needs this...????
    }
    get needsDiscovery() {
        return this.doDiscovery !== undefined ? this.doDiscovery : false;
    }
    get fileTypeSupportsTargetParquet() {
        return true;
    }
    get fileTypeSupportsDataPreprocess() {
        return true;
    }
    get isFileTypeCsv() {
        return true;
    }
    get shouldTargetCleanData() {
        return true;
    }
};
S3CsvImportConfig = S3CsvImportConfig_1 = __decorate([
    JsonSchemaV2(s3CsvImportConfigSchema, s3CsvImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.S3Csv)
], S3CsvImportConfig);
export { S3CsvImportConfig };
//# sourceMappingURL=s3CsvImportConfig.js.map